import type { Mate } from '@merels/room/types'

/**
 * Determines whether the local mates tracked for a client need to be resent
 * to the server based on the mates currently reported by the room state.
 */
export function needsMateResync(
  localMates: Mate[] | null,
  serverMates: Mate[] | undefined,
  clientId: string
): boolean {
  if (!localMates || localMates.length === 0) {
    return false
  }

  const serverForClient = (serverMates ?? []).filter((mate) => mate.clientId === clientId)
  if (serverForClient.length !== localMates.length) {
    return true
  }

  const serverMateIds = new Set(serverForClient.map((mate) => mate.mateId))
  return localMates.some((mate) => !serverMateIds.has(mate.mateId))
}
